import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PortalFiltersSheetProvider } from "@/contexts/portal-filters-sheet";
import { PortalFiltersSheet } from "@/components/portal/PortalFiltersSheet";

export const Route = createFileRoute("/portal-vip")({
  head: () => ({
    meta: [
      { title: "Portal VIP — Anuncios off-market — Bizaclia" },
      {
        name: "description",
        content:
          "Portal Bizaclia VIP: anuncios off-market verificados con documentación completa. Solo usuarios VIP verificados.",
      },
      { property: "og:title", content: "Portal VIP — Bizaclia" },
      {
        property: "og:description",
        content:
          "Anuncios off-market exclusivos para usuarios VIP verificados.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <PortalFiltersSheetProvider>
      <Outlet />
      <PortalFiltersSheet />
    </PortalFiltersSheetProvider>
  ),
});
